import { useState } from 'react';

import { Box, LinearProgress } from '@mui/material';

import useTimeout from '../../core/hooks/useTimeout';

interface AppLoadingProps {
  delay: number;
}
const AppLoading = ({ delay }: AppLoadingProps) => {
  const [showLoading, setShowLoading] = useState<boolean>(!delay);

  useTimeout(() => {
    setShowLoading(true);
  }, delay);

  if (!showLoading) {
    return null;
  }

  return (
    <Box>
      <LinearProgress color="primary" />
    </Box>
  );
};

export default AppLoading;
